import makeStyles from '@mui/styles/makeStyles';

const PAD = 2

const useStyles = makeStyles(theme => ({
  table: {
    flexBasis: `calc(45% - ${PAD * 2}rem)`,
    overflowX: 'hidden',
    padding: `0 ${PAD}rem`,

    [theme.breakpoints.down('lg')]: {
      maxWidth: `calc(100% - ${PAD * 2}rem)`
    },

    '& .table-root': {
      boxShadow: 'none',
      width: '100%',
      backgroundColor: 'transparent !important',
      overflow: 'hidden auto'
    },

    '& .table-row:hover': {
      backgroundColor: 'transparent !important'
    },

    '& .table-head, .table-data, .table-row': {
      border: 'none !important'
    },

    '& .wrapper': {
      overflow: 'unset !important'
    }
  }
}))

export default useStyles
